/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icon_send': {
    width: 21,
    height: 19,
    viewBox: '0 0 21 19',
    data: '<path pid="0" d="M2.389.446C1.538.07.639.869.906 1.763L2.61 7.535c.047.204.236.36.441.408L8.601 9.04c.552.11.536.878 0 .973L3.05 11.11a.582.582 0 00-.442.408L.903 17.29c-.268.894.646 1.679 1.482 1.318l17.223-8.097c.883-.377.883-1.6 0-1.976L2.388.446z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
